export enum DataDisplayType {
  Integral = 'Integral',
  Decimal0 = 'Decimal0',
  Decimal1 = 'Decimal1',
  Decimal2 = 'Decimal2',
  DecimalHours = 'DecimalHours',
  Icon = 'Icon',
  String = 'String',
  Date = 'Date',
  Time = 'Time',
  DateTime = 'DateTime',
  ReportBadge = 'ReportBadge',
}

export interface Column {
  field: string;
  header: string;
  type: DataDisplayType;
}
